//External libraries
import React from 'react';

//Internal modules
import { features, getContent } from '@/lib';
import { handleLanguageChange } from '../shared';
import { useMountLogging } from '@/lib/reactHooks';
import { LanguageButton, LanguageListContainer } from './StyledComponents';

const LanguageList = ({
  currLanguage,
}: {
  currLanguage: string;
}): JSX.Element => {
  useMountLogging('LanguageList');
  return (
    <LanguageListContainer>
      {features.config.enabledLanguages
        .filter((lang: string) => lang !== currLanguage)
        .map((lang: string) => (
          <LanguageButton
            data-testid={lang}
            key={lang}
            onClick={() => handleLanguageChange(lang)}
          >
            {getContent(`languages.${lang}`)}
          </LanguageButton>
        ))}
    </LanguageListContainer>
  );
};

export { LanguageList };
